// Escape a value before it goes into a hand-built HTML string (print windows, blobs).
// null/undefined become an empty string so templates keep printing.

export const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

export default escapeHtml;
